import {useState} from "react";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_RESERVATIONS} from "../common/api/apiConstants";
import {createURLQueryFromParams} from "../common/api/apiUtil";
import {RESERVATION_STATUS} from "../common/constant";

export const useReservations = () => {

    const {initialized, authenticated} = useKeycloakFunctions();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = (status) => {

        if (initialized && authenticated) {
            setLoading(true);
            setError(null);

            return bookingAPI.get(API_RESERVATIONS + createURLQueryFromParams({status: status || RESERVATION_STATUS.UPCOMING}), {redirectOnError: true})
                .then(res => {
                    setData(res.data);
                    return res.data;
                })
                .catch(err => {
                    setError(err);
                    setData([]);
                    throw err;
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            return new Promise(resolve => resolve());
        }
    };

    return {
        getReservations: getData,
        reservations: data,
        loadingReservations: loading,
        errorReservations: error
    };
};
